module.exports = __webpack_public_path__ + "images/backgrounds/hex.388d3a2dfa774508c095.png";